import { memo, ReactNode } from 'react';
import { IDataGridMadel } from '../model';
import Column from './column';
import Controls from './controls';
import Swap from './column/templates/swap';
import { GetGridRowProps } from '../types';

// const

interface Props<R = any> {
  model: IDataGridMadel;
  data: any[];
  onTasks: (tasks: any[]) => void;
  rowControls?: ReactNode;
  preview?: boolean;
  getRowProps?: GetGridRowProps<R>;
}
const Body = <R,>({ model, data, onTasks, rowControls, preview, getRowProps }: Props<R>) => {
  if (!model) return null;
  return (
    <tbody>
      {data &&
        data.map((item, index, array) => {
          const key = item[model.store.mainField];
          const rowProps = getRowProps?.({ row: item, index });
          const rowUp = array[index - 1] ?? null;
          const rowDown = array[index + 1] ?? null;
          return (
            <tr key={key} {...rowProps}>
              {!preview && model.store.swap && model.store.swap.field && (
                <Swap rowData={item} rowUp={rowUp} rowDown={rowDown} />
              )}
              {model.columns.map((column) => (
                <Column
                  key={`${key}-${column.field}`}
                  column={column}
                  data={item}
                  onTasks={onTasks}
                  preview={preview}
                />
              ))}
              {!preview && (model.controls || rowControls) && (
                <Controls
                  controls={model.controls}
                  data={item}
                  id={key}
                  onTasks={onTasks}
                  rowControls={rowControls}
                />
              )}
            </tr>
          );
        })}
    </tbody>
  );
};

export default memo(Body);
